import IconBase from "./IconBase";

const FillFrameIcon = props => (
  <IconBase data-testid="FillFrameIcon" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="m12 12 4 4m1-3v4h-4M8 8 4 4M3 7V3h4M8 12l-4 4m3 1H3v-4M12 8l4-4m-3-1h4v4"
    />
  </IconBase>
);

export default FillFrameIcon;
